export function getNameInfo(name) {
    const url = new URL(name, 'ium:/');
    return {
        url,
        name: url.pathname.split('/').pop(),
        relativePath: url.pathname,
    };
}
//# sourceMappingURL=getNameInfo.js.map